import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { productPaths } from './paths';

const { Product } = lazyImport(() => import('@sternum/web/features/product/views/product'), 'Product');
const { Products } = lazyImport(() => import('@sternum/web/features/product/views/products'), 'Products');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const productRoutes: RouteObject[] = [
  {
    path: productPaths.absolute,
    element: <Layout />,
    children: [
      {
        path: '',
        element: <Products />,
      },
      {
        path: productPaths.singleProduct.relative,
        element: <Product />,
      },
    ],
  },
];
